import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "../../../utils";

import { PlayerCharacterComponent } from "../rightbar/topplayers";
import CharacterInventoryItemComponent from "./inventory";
import { CharacterSkillComponent, CharacterStatsComponent } from "./stats_skills";

import './index.css';

const CharacterProfileComponent = ({id}) => {
    const [characterInformation, setCharacterInformation] = useState(null);

    const getCharacterInformation = useCallback(async (id) => {
        const response = await apiFetch('/user/character', 'POST', {id: id});
        if (response.code === 'success') setCharacterInformation(response.data);
    }, []);

    useEffect(() => {
        if (!characterInformation || (parseInt(id) !== parseInt(characterInformation.id))) {
            getCharacterInformation(id);
        };
    }, [characterInformation, getCharacterInformation, id]);

    if (!characterInformation) return <div id='character-profile-container'>
        <h2 style={{textAlign: 'center'}}>Loading...</h2>
    </div>;

    return (
        <div id='character-profile-container'>

            <div id='character-profile-name-container'>
                <h2 id='character-profile-name'>
                    {characterInformation.name} {characterInformation.title} 
                </h2>
                {characterInformation.guild_name && <span id='character-profile-guild-name' title='TODO: Guild Link'>({characterInformation.guild_name})</span>}
            </div>
            <PlayerCharacterComponent data={characterInformation} showName={false} width='140px' height='140px'/>

            <div id='character-profile-information-container'>
                <div className='character-profile-information'>
                    <CharacterStatsComponent characterInformation={characterInformation}/>
                </div>

                <div className='character-profile-information'>
                    <CharacterSkillComponent characterInformation={characterInformation}/>
                </div>
            </div>

            <div id='character-profile-inventory-container'>
                <div id='character-profile-inventory-items-container'>
                    {characterInformation?.items?.map((el, i) => <CharacterInventoryItemComponent key={i} item={el}/>)}
                </div>
            </div>
        </div>
    );
};

export default CharacterProfileComponent;